import Firestore from '../initFirebase'
import { globalOnDemandVars } from '../../helper/context'
import { Type2Or3Item } from '../../components/list/uploadType2/class'
import { Fragment } from '../../components/list/uploadType2/fragment'

export async function initUploadType2s () {
  globalOnDemandVars.set_uploadType2Ready(false)

  if (process.env.NODE_ENV !== 'production') {
    console.tron.log('initUploadType2s 1')
  }

  const collection = Firestore.collection('users').doc(globalOnDemandVars.userData().uid).collection('UploadType2s').orderBy('timeStamp', 'desc')
  const snapshot = await collection.get()

  if (process.env.NODE_ENV !== 'production') {
    console.tron.log('initUploadType2s 2')
  }

  const uploadType2s = {}
  const uploadType2sInWaitingList = []
  const setFragmentListFunctions = []
  try {
    snapshot.forEach((doc) => {
      const documentData = doc.data()
      if (documentData.type !== 'Code' && documentData.type !== 'LaTeX') { documentData.content = JSON.parse(documentData.content) }
      const type2Item = new Type2Or3Item({ id: doc.id, ...documentData })
      uploadType2s[doc.id] = type2Item
      if (typeof documentData.inWaitingList === 'undefined' || documentData.inWaitingList === true) {
        uploadType2sInWaitingList.push(type2Item)
      }

      const fragmentCollection = Firestore.collection('users').doc(globalOnDemandVars.userData().uid).collection('UploadType2s').doc(doc.id).collection('Fragments').orderBy('timeStamp', 'desc')

      const setFragments = async () => {
        const fragmentSnapshot = await fragmentCollection.get()

        const fragments = []
        fragmentSnapshot.forEach((fragmentDoc) => {
          const fragmentData = fragmentDoc.data()
          if (process.env.NODE_ENV !== 'production') {
            console.tron.display({
              name: 'uploadType2 / initData - fragmentData',
              value: {
                fragmentData, type2Item
              }
              // , important: true
            })
          }
          if (process.env.NODE_ENV !== 'production') {
            console.tron.display({
              name: 'uploadType2 / initData - fragmentData 2',
              value: {
                content: fragmentData.content
              }
              // , important: true
            })
          }
          fragments.push(new Fragment({ id: fragmentDoc.id, ...fragmentData }))
          if (process.env.NODE_ENV !== 'production') {
            console.tron.log('uploadType2 / initData - fragmentData 3')
          }
        })
        type2Item.setFragmentListWithoutDB(fragments)
        if (process.env.NODE_ENV !== 'production') {
          console.tron.log('uploadType2 / initData - fragmentData 4')
        }
      }

      setFragmentListFunctions.push(setFragments)
    })
  } catch (e) {
    if (process.env.NODE_ENV !== 'production') {
      console.tron.display({
        name: 'uploadType2 / initUploadType2s 2.5',
        value: {
          e
        }
        // , important: true
      })
    }
  }

  if (process.env.NODE_ENV !== 'production') {
    console.tron.log('initUploadType2s 3')
  }

  await Promise.all(setFragmentListFunctions.map((setFragments) => (setFragments())))

  if (process.env.NODE_ENV !== 'production') {
    console.tron.log('initUploadType2s 4')
  }

  globalOnDemandVars.set_uploadType2s(uploadType2s)
  globalOnDemandVars.set_uploadType2sInWaitingList(uploadType2sInWaitingList)

  if (process.env.NODE_ENV !== 'production') {
    console.tron.log('initUploadType2s 5')
  }

  globalOnDemandVars.set_uploadType2Ready(true)
}
